import React from "react"

const  SpinnerDiv = ({size}) =>
{
	const lineList = [1,2,3,4,5,6,7,8,9,10,11,12].map((num) =>
	{
		return <div key={'circ' + num} className={'sk-circle sk-circle-' + num} />
	}) ;

	return <div key='outerDelete' className={'sk-fading-circle ' + size}>{ lineList }</div>
}

export default SpinnerDiv ;

